import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/rootEnums";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/home",
    component: () => import("@/layout/joymeet/Layout.vue"),
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/Home.vue")
      },
    ]
  },
  {
    path: "/callback",
    name: "callback",
    component: () => import("@/views/auth/Callback.vue")
  },
  {
    path: "/silent-renew",
    name: "silent-renew",
    // redirect: "/home",
    component: () => import("@/views/auth/SilentRenew.vue")
    //component: () => import("@/views/Home.vue")
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/layout/joymeet/Layout.vue"),
    children: [
      {
        path: "/404",
        name: "404",
        component: () => import("@/views/error/Error404.vue")
      },
    ]
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/layout/joymeet/Layout.vue"),
    children: [
      {
        path: "/500",
        name: "500",
        component: () => import("@/views/error/Error500.vue")
      },
    ]
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404"
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(() => {
  // reset config to initial state
  //store.commit(Mutations.RESET_LAYOUT_CONFIG);

  store.dispatch(Actions.VERIFY_AUTH);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router
